export const SUPPORTED_IMAGE_TYPES = {
  "image/jpeg": [],
  "image/png": [],
};

export const ACCEPTED_IMAGE_TYPES_LABEL =
  "Accepted file types: .PNG, .JPEG, and .JPG";

const KB = 1024;
const MB = KB * KB;

export const MIN_FILE_SIZE = 0;
export const MAX_FILE_SIZE = 20 * MB;
